export const SORT_DIRECTION_ASC = 'asc'
export const SORT_DIRECTION_DESC = 'desc'

export const sortReports = ({ reports, sortBy, sortDirection }) => {
  reports.sort((a, b) => {
    if (isGreaterThan(a[sortBy], b[sortBy], sortBy)) return 1
    else if (isLowerThan(a[sortBy], b[sortBy], sortBy)) return -1
    else return 0
  })
  if (sortDirection === SORT_DIRECTION_DESC) {
    reports.reverse()
  }
  return reports
}

const isGreaterThan = (a, b, sortBy) => {
  if (sortBy == 'date') {
    return a.isAfter(b)
  } else if (typeof a === 'number') {
    return a > b
  } else {
    return a.toLowerCase() > b.toLowerCase()
  }
}

const isLowerThan = (a, b, sortBy) => {
  if (sortBy == 'date') {
    return b.isAfter(a)
  } else if (typeof a === 'number') {
    return a < b
  } else {
    return a.toLowerCase() < b.toLowerCase()
  }
}
